import { render, staticRenderFns } from "./AutoSacrificeEffectTab.vue?vue&type=template&id=6b3bd4d6&scoped=true"
import script from "./AutoSacrificeEffectTab.vue?vue&type=script&lang=js"
export * from "./AutoSacrificeEffectTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3bd4d6",
  null
  
)

export default component.exports